import React, { Component,Fragment }  from 'react';
import {Menu, Button, Tooltip, Steps} from 'antd';
import Header from "./Header";
import EnterpriseRegistration from './NationalPages/EnterpriseRegistration';
import RegisterCertificatePapers from './QualificationCertificate/RegisterCertificatePapers';
import TechnicalFieldDescription from "./QualificationCertificate/TechnicalFieldDescription";
import IPNonReuse from "./IntellectualProperty/IPNonReuse";
import IPSummaryTable from "./IntellectualProperty/IPSummaryTable";
import IPUploadSupportPapers from "./IntellectualProperty/IPUploadSupportPapers";
import {createHashHistory} from "history";
import {
        HomeFilled,
        ReadFilled,
        MessageOutlined,
        ClusterOutlined,
        BellOutlined,
        YoutubeOutlined,
        ThunderboltFilled,
		GlobalOutlined,
		HddFilled,
	MenuUnfoldOutlined,
	MenuFoldOutlined,
	StarOutlined,
	FileZipOutlined
} from '@ant-design/icons';
import ResearchAuditReport from "./AuditReport/ResearchAuditReport";
import ProductAuditReport from "./AuditReport/ProductAuditReport";
import FinancialAuditReport from "./AuditReport/FinancialAuditReport";
import TaxForm from "./AuditReport/TaxForm";
import IntermediaryProof from "./AuditReport/IntermediaryProof";
import IPGeneralSituation from "./IntellectualProperty/IPGeneralSituation";
import IPFunction from "./IntellectualProperty/IPFunction";
import IPSummaryTableQingdao from "./IntellectualProperty/IPSummaryTableQingdao";
import PatentTransferSummaryQingdao from './PatentTransfer/PatentTransferSummaryQingdao';
import PatentTransferSummary from './PatentTransfer/PatentTransferSummary';
import OverallCondition from './PatentTransfer/OverallCondition';
import ItemCondition from './PatentTransfer/ItemCondition';
import SupportingPapers from './PatentTransfer/SupportingPapers';
import SupportingPapersQingdao from "./PatentTransfer/SupportingPapersQingdao";
import BuildProjectSummary from "./BuildProject/BuildProjectSummary";
import BuildProjectResolution from "./BuildProject/BuildProjectResolution";
import ProjectReport from "./BuildProject/ProjectReport";
import ReceivingReport from "./BuildProject/ReceivingReport";
import StaffSituation from "./Staff/StaffSituation";
import StaffRoster from "./Staff/StaffRoster";
import StaffStructure from "./Staff/StaffStructure";
import StaffSecurity from "./Staff/StaffSecurity";
import HighTechSpecific from "./HighTech/HighTechSpecific";
import HighTechUpload from "./HighTech/HighTechUpload";
import OrganizationOverAll from "./organization/OrganizationOverAll";
import OrganizationItem from "./organization/OrganizationItem";
import RDProjectManage from "./organization/RDProjectManage";
import RDCenterFound from "./organization/RDCenterFound";
import RDCenter from "./organization/RDCenter";
import RDEquipment from "./organization/RDEquipment";
import RDExpense from "./organization/RDExpense";
import RDInvestManage from "./organization/RDInvestManage";
import RDAuxiliaryAccount from "./organization/RDAuxiliaryAccount";
import ReserveFund from "./organization/ReserveFund";
import SchoolProtocol from "./organization/SchoolProtocol";
import PatentTransferManage from "./organization/PatentTransferManage";
import OpenInnovation from "./organization/OpenInnovation";
import TechPersonTrain from "./organization/TechPersonTrain";
import TechPersonRefresh from "./organization/TechPersonRefresh";
import TalentAcquisition from "./organization/TalentAcquisition";
import PerformanceReview from "./organization/PerformanceReview";
import RDEquipmentPhoto from "./organization/RDEquipmentPhoto";
import HonorQualification from "./HonorQualification";
import CompanyPaceMain from "./CompanyPaceMain";
import FinallyFile from "./FinallyFile";
import {fetchPost} from "../static/util/fetch";
import OtherReport from "./AuditReport/OtherReport";
import BuildProject from "./BuildProject/BuildProject";
const  { SubMenu }  = Menu;

class Navigation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tabBar: 11,
			companyName: localStorage.getItem("companyName"),
			companyId:parseInt(localStorage.getItem("companyId")),
			area: localStorage.getItem("area"),
			collapsed:false,
			visible:false,
			current:1,
			RegisterCertificatePapersStatus: false,
			TechnicalFieldDescriptionStatus:false,
			IPNonReuseStatus:false,
			IPSummaryTableStatus:false,
			IPGeneralSituationStatus:false,
			IPFunctionStatus:false,
			IPUploadSupportPapersStatus:false,
			ResearchAuditReportStatus:false,
			ProductAuditReportStatus:false,
			FinancialAuditReportStatus:false,
			TaxFormStatus:false,
			IntermediaryProofStatus:false,
			PatentTransferSummaryStatus:false,
			PatentTransferSummaryQingdaoStatus:false,
			OverallConditionStatus:false,
			ItemConditionStatus:false,
			BuildProjectSummaryStatus:false,
			BuildProjectResolutionStatus1:false,
			BuildProjectResolutionStatus2:false,
			BuildProjectResolutionStatus3:false,
			ProjectReportStatus:false,
			ReceivingReportStatus:false,
			StaffSituationStatus:false,
			StaffRosterStatus:false,
			StaffStructureStatus:false,
			StaffSecurityStatus:false,
			HighTechSpecificStatus:false,
			OpenInnovationStatus:false,
			OrganizationItemStatus:false,
			OrganizationOverAllStatus:false,
			PatentTransferManageStatus:false,
			PerformanceReviewStatus:false,
			RDAuxiliaryAccountStatus:false,
			RDCenterStatus:false,
			RDCenterFoundStatus:false,
			RDEquipmentStatus:false,
			RDInvestManageStatus:false,
			RDProjectManageStatus:false,
			ReserveFundStatus:false,
			TalentAcquisitionStatus:false,
			TechPersonRefreshStatus:false,
			TechPersonTrainStatus:false,
			RDEquipmentPhotoStatus:false,
			RDExpenseStatus:false,
			SchoolProtocolStatus:false,
			HonorQualificationStatus:false,
			systemName:'',
		}
	}
	componentDidMount() {
		fetchPost(global.constants.getSysConfig,{})
			.then(
				res=>{
					if(res.code === 200){
						this.setState(()=>({
							systemName:res.data.systemName,
						}))
						if(res.data.systemColor === 1){
							require([`../style.css`], function(list){});
						}
						if(res.data.systemColor === 2){
							require([`../styleOrange.css`], function(list){});
						}
						if(res.data.systemColor === 3){
							require([`../styleGray.css`], function(list){});
						}
					}
				}
			)
	}
	handleChangeTabBar = (tabBar) => {
		this.setState({
			tabBar: tabBar
		})
		switch (tabBar) {
			case 11:
				createHashHistory().push('/navigation/CompanyPaceMain')
				break
			case 0:
				createHashHistory().push('/navigation/enterpriseregistration')
				break
			case 0.1:
				createHashHistory().push('/navigation/0_1')
				break
			case 0.2:
				createHashHistory().push('/navigation/0_2')
				break
			case 0.3:
				createHashHistory().push('/navigation/0_3')
				break
			case 0.4:
				createHashHistory().push('/navigation/0_4')
				break
			case 0.5:
				createHashHistory().push('/navigation/0_5')
				break
			case 0.6:
				createHashHistory().push('/navigation/0_6')
				break
			case 0.7:
				createHashHistory().push('/navigation/0_7')
				break
			case 0.8:
				createHashHistory().push('/navigation/0_8')
				break
			case 0.9:
				createHashHistory().push('/navigation/0_9')
				break
			case 1.1:
				createHashHistory().push('/navigation/registercertificatepapers')
				break
			case 1.2:
				createHashHistory().push('/navigation/technicalfielddescription')
				break
			case 2.1:
				createHashHistory().push('/navigation/ipnonreuse')
				break
			case 2.2:
				(this.state.area === '青岛')?createHashHistory().push('/navigation/ipsummarytableqingdao'):createHashHistory().push('/navigation/ipsummarytable')
				break
			case 2.3:
				createHashHistory().push('/navigation/ipgeneralsituation')
				break
			case 2.4:
				createHashHistory().push('/navigation/IPUploadsupportpapers')
				break
			case 2.5:
				createHashHistory().push('/navigation/ipfunction')
				break
			case 3.1:
				createHashHistory().push('/navigation/researchauditreport')
				break
			case 3.2:
				createHashHistory().push('/navigation/productauditreport')
				break
			case 3.3:
				createHashHistory().push('/navigation/financialauditreport')
				break
			case 3.4:
				createHashHistory().push('/navigation/taxform')
				break
			case 3.5:
				createHashHistory().push('/navigation/intermediaryproof')
				break
			// case 3.6:
			// 	createHashHistory().push('/navigation/otherReport')
			// 	break
			case 4.1:
				(this.state.area === '青岛')?createHashHistory().push('/navigation/patenttransfersummaryqingdao'):createHashHistory().push('/navigation/patenttransfersummary')
				break
			case 4.2:
				createHashHistory().push('/navigation/overallcondition')
				break
			case 4.3:
				createHashHistory().push('/navigation/itemcondition')
				break
			case 4.4:
				(this.state.area === '青岛')?createHashHistory().push('/navigation/supportingpapersQingdao'):createHashHistory().push('/navigation/supportingpapers')
				break
			case 5.1:
				createHashHistory().push('/navigation/buildprojectsummary')
				break
			case 5:
				createHashHistory().push('/navigation/buildProject')
				break
			// case 5.2:
			// 	createHashHistory().push('/navigation/buildprojectresolution')
			// 	break
			// case 5.3:
			// 	createHashHistory().push('/navigation/projectreport')
			// 	break
			// case 5.4:
			// 	createHashHistory().push('/navigation/receivingreport')
			// 	break
			case 6.1:
				createHashHistory().push('/navigation/staffSituation')
				break
			case 6.2:
				createHashHistory().push('/navigation/staffRoster')
				break
			case 6.3:
				(this.state.area === '江苏')?createHashHistory().push('/navigation/staffStructureJiangsu'):createHashHistory().push('/navigation/staffStructure')
				break
			case 6.4:
				createHashHistory().push('/navigation/staffSecurity')
				break
			case 7.1:
				createHashHistory().push('/navigation/highTechSpecific')
				break
			case 7.2:
				createHashHistory().push('/navigation/highTechUpload')
				break
			case 8.1:
				createHashHistory().push('/navigation/organizationOverAll')
				break
			case 8.2:
				createHashHistory().push('/navigation/organizationItem')
				break
			case 8.3:
				createHashHistory().push('/navigation/RDProjectManage')
				break
			case 8.4:
				createHashHistory().push('/navigation/RDInvestManage')
				break
			case 8.5:
				createHashHistory().push('/navigation/RDAuxiliaryAccount')
				break
			case 8.6:
				createHashHistory().push('/navigation/ReserveFund')
				break
			case 8.7:
				createHashHistory().push('/navigation/RDCenterFound')
				break
			case 8.8:
				createHashHistory().push('/navigation/RDCenter')
				break
			case 8.9:
				createHashHistory().push('/navigation/RDEquipment')
				break
			case 9:
				createHashHistory().push('/navigation/SchoolProtocol')
				break
			case 8.11:
				createHashHistory().push('/navigation/PatentTransferManage')
				break
			case 8.12:
				createHashHistory().push('/navigation/OpenInnovation')
				break
			case 8.13:
				createHashHistory().push('/navigation/TechPersonTrain')
				break
			case 8.14:
				createHashHistory().push('/navigation/TechPersonRefresh')
				break
			case 8.15:
				createHashHistory().push('/navigation/TalentAcquisition')
				break
			case 8.16:
				createHashHistory().push('/navigation/PerformanceReview')
				break
			case 8.17:
				createHashHistory().push('/navigation/RDEquipmentPhoto')
				break
			case 8.18:
				createHashHistory().push('/navigation/RDExpense')
				break
			case 10:
				createHashHistory().push('/navigation/honorQualification')
				break
			case 11:
				createHashHistory().push('/navigation/finallyFile')
				break
			default:
				break
		}
	}
	returnLists = () =>{
		let history = this.props.history;
		history.push('/companylistnavigation')
	}
	show(){
		return(
			<Tooltip title="知识产权对主要产品（服务）在技术上发挥核心支持作用介绍（选填，青岛有）">
				<span>知识产权对主要产品（服务）在技术上发挥核心支持作用介绍（选填，青岛有）</span>
			</Tooltip>
		)
	}
	toggleCollapsed(){
		this.setState(()=>({
			collapsed:!this.state.collapsed
		}))
	}
	render() {
		return (
			<Fragment>
				<Header history={this.props.history}/>
				<div>
					<Menu
						//onClick={this.handleClick}
						className={this.state.collapsed?"Navigation-close":"Navigation-open"}
						defaultSelectedKeys={["0"]}
						mode="inline"
						theme="light"
						inlineCollapsed={this.state.collapsed}
					>
						<Button
							style={{marginTop:"10px"}}
							type="primary"
							onClick={this.toggleCollapsed.bind(this)}
							icon={
								this.state.collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>
							}
						/>
						<div style={{marginLeft:'20%',padding:'8%'}}>
							<Button
								shape='round'
								style={{display:this.state.collapsed?'none':'inline'}}
								onClick={this.returnLists}
							>
								返回上一级</Button>
						</div>
						<Menu.Item
							key="11"
							icon={<FileZipOutlined style={{fontSize: '25px'}}/>}
							onClick={this.handleChangeTabBar.bind(this, 11)}>查看进度</Menu.Item>
						<SubMenu
							key="sub0"
							align="left"
							icon={<GlobalOutlined style={{fontSize: '25px'}}/>}
							title="国网填报内容"
							disabled
						>
							<Menu.Item key="0" onClick={this.handleChangeTabBar.bind(this, 0)}>企业注册登记表</Menu.Item>
							<Menu.Item key="0.1" onClick={this.handleChangeTabBar.bind(this, 0.1)}>主要情况表</Menu.Item>
							<Menu.Item key="0.2" onClick={this.handleChangeTabBar.bind(this, 0.2)}>知识产权汇总表</Menu.Item>
							<Menu.Item key="0.3" onClick={this.handleChangeTabBar.bind(this, 0.3)}>人力资源情况表</Menu.Item>
							<Menu.Item key="0.4"
									   onClick={this.handleChangeTabBar.bind(this, 0.4)}>企业研究开发活动情况表</Menu.Item>
							<Menu.Item key="0.5"
									   onClick={this.handleChangeTabBar.bind(this, 0.5)}>企业年度研究开发费用结构明细表</Menu.Item>
							<Menu.Item key="0.6"
									   onClick={this.handleChangeTabBar.bind(this, 0.6)}>上年度高新技术产品(服务)情况表</Menu.Item>
							<Menu.Item key="0.7" onClick={this.handleChangeTabBar.bind(this, 0.7)}>企业创新能力</Menu.Item>
							<Menu.Item key="0.8" onClick={this.handleChangeTabBar.bind(this, 0.8)}>加分项</Menu.Item>
							<Menu.Item key="0.9" onClick={this.handleChangeTabBar.bind(this, 0.9)}>附件清单</Menu.Item>
						</SubMenu>

						<SubMenu key="sub1" icon={<HomeFilled style={{fontSize: '25px'}}/>} title="资质证明">
							<Menu.Item key="1.1" onClick={this.handleChangeTabBar.bind(this, 1.1)}>营业执照</Menu.Item>
							<Menu.Item
								key="1.2"
								onClick={this.handleChangeTabBar.bind(this, 1.2)}
								disabled={this.state.area === '江苏'}
							>技术领域说明</Menu.Item>
						</SubMenu>
						<SubMenu key="sub2" icon={<HddFilled style={{fontSize: '25px'}}/>} title="知识产权">
							<Menu.Item
								key="2.1"
								onClick={this.handleChangeTabBar.bind(this, 2.1)}
							>知识产权未重复使用说明</Menu.Item>
							<Menu.Item key="2.2" onClick={this.handleChangeTabBar.bind(this, 2.2)}>知识产权情况汇总表</Menu.Item>
							<Menu.Item
								key="2.3"
								onClick={this.handleChangeTabBar.bind(this, 2.3)}
								disabled={this.state.area !== '青岛'}
							>知识产权概况（选填，青岛有）</Menu.Item>
							<Menu.Item key="2.4" onClick={this.handleChangeTabBar.bind(this, 2.4)}>知识产权证明材料</Menu.Item>
							<Menu.Item
								key="2.5"
								onClick={this.handleChangeTabBar.bind(this, 2.5)}
								disabled={this.state.area !== '青岛'}
							>
								{this.show()}
							</Menu.Item>
						</SubMenu>
						<SubMenu key="sub3" icon={<ReadFilled style={{fontSize: '25px'}}/>} title="审计报告">
							<Menu.Item key="3.1" onClick={this.handleChangeTabBar.bind(this, 3.1)}>研发费用专项审计报告</Menu.Item>
							<Menu.Item key="3.2" onClick={this.handleChangeTabBar.bind(this, 3.2)}>高品专项审计报告</Menu.Item>
							<Menu.Item key="3.3" onClick={this.handleChangeTabBar.bind(this, 3.3)}>财务审计报告</Menu.Item>
							<Menu.Item key="3.4" onClick={this.handleChangeTabBar.bind(this, 3.4)}>纳税申报表</Menu.Item>
							<Menu.Item key="3.5" onClick={this.handleChangeTabBar.bind(this, 3.5)}>中介机构证明</Menu.Item>
						</SubMenu>
						<SubMenu key="sub4" icon={<MessageOutlined style={{fontSize: '25px'}}/>} title="成果转化">
							<Menu.Item key="4.1" onClick={this.handleChangeTabBar.bind(this, 4.1)}>近三年成果转化汇总表</Menu.Item>
							<Menu.Item key="4.2" onClick={this.handleChangeTabBar.bind(this, 4.2)}>科技成果转化总体情况说明</Menu.Item>
							<Menu.Item key="4.3" onClick={this.handleChangeTabBar.bind(this, 4.3)}>科技成果逐项说明</Menu.Item>
							<Menu.Item key="4.4" onClick={this.handleChangeTabBar.bind(this, 4.4)}>证明材料</Menu.Item>
						</SubMenu>
						<SubMenu key="sub5"
								 icon={<ClusterOutlined style={{fontSize: '25px'}}/>}
								 title="立项">
							<Menu.Item key="5.1" onClick={this.handleChangeTabBar.bind(this, 5.1)}>项目立项汇总表</Menu.Item>
							<Menu.Item key="5" onClick={this.handleChangeTabBar.bind(this, 5)}>立项材料</Menu.Item>
							{/*<Menu.Item key="5.2" onClick={this.handleChangeTabBar.bind(this, 5.2)}>立项决议</Menu.Item>*/}
							{/*<Menu.Item key="5.3" onClick={this.handleChangeTabBar.bind(this, 5.3)}>项目研究开发设计书</Menu.Item>*/}
							{/*<Menu.Item key="5.4" onClick={this.handleChangeTabBar.bind(this, 5.4)}>项目验收报告</Menu.Item>*/}
						</SubMenu>
						<SubMenu key="sub6" icon={<BellOutlined style={{fontSize: '25px'}}/>} title="人员">
							<Menu.Item
								key="6.1"
								onClick={this.handleChangeTabBar.bind(this, 6.1)}
								disabled={this.state.area !== '江苏'}
							>人员情况表（选填,江苏有）</Menu.Item>
							<Menu.Item key="6.2" onClick={this.handleChangeTabBar.bind(this, 6.2)}>科技人员花名册</Menu.Item>
							<Menu.Item
								key="6.3"
								onClick={this.handleChangeTabBar.bind(this, 6.3)}
								disabled={this.state.area === '山东其他地区'}
							>人员结构表</Menu.Item>
							<Menu.Item key="6.4" onClick={this.handleChangeTabBar.bind(this, 6.4)}>社保缴费证明</Menu.Item>
						</SubMenu>
						<SubMenu
							key="sub7"
							icon={<YoutubeOutlined style={{fontSize: '25px'}}/>}
							title="高品"
							disabled={this.state.area === '青岛'}
						>
							<Menu.Item key="7.1" onClick={this.handleChangeTabBar.bind(this, 7.1)}>高品技术和技术指标具体说明</Menu.Item>
							<Menu.Item
								key="7.2"
								onClick={this.handleChangeTabBar.bind(this, 7.2)}
								disabled={this.state.area !== '江苏'}
							>证明材料（选填,江苏有）</Menu.Item>
						</SubMenu>
						<SubMenu key="sub8" icon={<ThunderboltFilled style={{fontSize: '25px'}}/>} title="组织管理">
							<Menu.Item key="8.1" onClick={this.handleChangeTabBar.bind(this, 8.1)}>研究开发组织管理水平总体情况说明</Menu.Item>
							<Menu.Item key="8.2" onClick={this.handleChangeTabBar.bind(this, 8.2)}>研究开发组织管理水平指标逐项说明</Menu.Item>
							<Menu.Item key="8.3" onClick={this.handleChangeTabBar.bind(this, 8.3)}>研发项目管理制度</Menu.Item>
							<Menu.Item key="8.4" onClick={this.handleChangeTabBar.bind(this, 8.4)}>研发投入核算管理制度</Menu.Item>
							<Menu.Item key="8.5" onClick={this.handleChangeTabBar.bind(this, 8.5)}>研发辅助账管理办法</Menu.Item>
							<Menu.Item key="8.6" onClick={this.handleChangeTabBar.bind(this, 8.6)}>企业研发准备金制度</Menu.Item>
							<Menu.Item key="8.7" onClick={this.handleChangeTabBar.bind(this, 8.7)}>关于成立研发中心的通知</Menu.Item>
							<Menu.Item key="8.8" onClick={this.handleChangeTabBar.bind(this, 8.8)}>研发中心建设情况说明</Menu.Item>
							<Menu.Item key="8.9" onClick={this.handleChangeTabBar.bind(this, 8.9)}>研发设备明细表</Menu.Item>
							<Menu.Item key="9" onClick={this.handleChangeTabBar.bind(this, 9)}>产学研协议（选填）</Menu.Item>
							<Menu.Item key="8.11" onClick={this.handleChangeTabBar.bind(this, 8.11)}>科技成果转化的组织实施与激励奖励制度</Menu.Item>
							<Menu.Item key="8.12" onClick={this.handleChangeTabBar.bind(this, 8.12)}>开放式创新创业平台制度</Menu.Item>
							<Menu.Item key="8.13" onClick={this.handleChangeTabBar.bind(this, 8.13)}>科技人员培训管理制度</Menu.Item>
							<Menu.Item key="8.14" onClick={this.handleChangeTabBar.bind(this, 8.14)}>科技人员培养进修制度</Menu.Item>
							<Menu.Item key="8.15" onClick={this.handleChangeTabBar.bind(this, 8.15)}>人才引进制度</Menu.Item>
							<Menu.Item key="8.16" onClick={this.handleChangeTabBar.bind(this, 8.16)}>研发人员绩效考核制度</Menu.Item>
							<SubMenu key="sub9" icon={<ThunderboltFilled style={{fontSize: '20px'}}/>} title="证明材料">
								<Menu.Item key="8.17" onClick={this.handleChangeTabBar.bind(this, 8.17)}>研发设备照片</Menu.Item>
								<Menu.Item key="8.18" onClick={this.handleChangeTabBar.bind(this, 8.18)}>研发费用辅助帐（选填）</Menu.Item>
							</SubMenu>
						</SubMenu>
						<Menu.Item
							key="10"
							icon={<StarOutlined style={{fontSize: '25px'}}/>}
							onClick={this.handleChangeTabBar.bind(this, 10)}>荣誉资质</Menu.Item>
						<Menu.Item
							key="12"
							icon={<FileZipOutlined style={{fontSize: '25px'}}/>}
							onClick={this.handleChangeTabBar.bind(this, 12)}>文件合成</Menu.Item>
					</Menu>
					<div>
					{!this.state.collapsed?
					<div className="content-frame-open">
						<div className="content-form-open">
							{
								this.state.tabBar === 11 &&(
									<CompanyPaceMain companyName={this.state.companyName} companyId={this.state.companyId}/>
								)
							}
							{this.state.tabBar === 0 && (
								<EnterpriseRegistration/>
							)
							}
							{this.state.tabBar === 0.1 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.2 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.3 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.4 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.5 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.6 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.7 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.8 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.9 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 1.1 && (
								<RegisterCertificatePapers companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 1.2 && (
								<TechnicalFieldDescription companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.1 && (
								<IPNonReuse companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.2 && (
								(this.state.area === '青岛')?
									<IPSummaryTableQingdao
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>:
									<IPSummaryTable
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>
							)
							}
							{this.state.tabBar === 2.3 && (
								<IPGeneralSituation companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.4 && (
								<IPUploadSupportPapers companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.5 && (
								<IPFunction companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.1 && (
								<ResearchAuditReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.2 && (
								<ProductAuditReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.3 && (
								<FinancialAuditReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.4 && (
								<TaxForm companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.5 && (
								<IntermediaryProof companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 4.1 && (
								(this.state.area === '青岛')?
									<PatentTransferSummaryQingdao
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>:
									<PatentTransferSummary
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>
							)
							}
							{this.state.tabBar === 4.2 && (
								<OverallCondition companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 4.3 && (
								<ItemCondition companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 4.4 && (
								<SupportingPapersQingdao
									companyName={this.state.companyName}
									companyId={this.state.companyId}
								/>
								// (this.state.area === '青岛')?
								// 	<SupportingPapersQingdao
								// 		companyName={this.state.companyName}
								// 		companyId={this.state.companyId}
								// 	/>:
								// 	<SupportingPapers
								// 		companyName={this.state.companyName}
								// 		companyId={this.state.companyId}
								// 	/>
							)
							}

							{this.state.tabBar === 5.1 && (
								<BuildProjectSummary companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5 && (
								<BuildProject companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.2 && (
								<BuildProjectResolution companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.3 && (
								<ProjectReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.4 && (
								<ReceivingReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 6.1 && (
								<StaffSituation companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 6.2 && (
								<StaffRoster companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 6.3 && (
								<StaffStructure
									companyName={this.state.companyName}
									companyId={this.state.companyId}
								/>
								// (this.state.area === '江苏')?
								// 	<StaffStructureJiangsu
								// 		companyName={this.state.companyName}
								// 		companyId={this.state.companyId}
								// 	/>:
								// 	<StaffStructure
								// 		companyName={this.state.companyName}
								// 		companyId={this.state.companyId}
								// 	/>
							)
							}
							{this.state.tabBar === 6.4 && (
								<StaffSecurity companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 7.1 && (
								<HighTechSpecific companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 7.2 && (
								<HighTechUpload  companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.1 && (
								<OrganizationOverAll companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.2 && (
								<OrganizationItem  companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.3 && (
								<RDProjectManage companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.4 && (
								<RDInvestManage companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.5 && (
								<RDAuxiliaryAccount companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.6 && (
								<ReserveFund companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.7 && (
								<RDCenterFound companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.8 && (
								<RDCenter companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.9 && (
								<RDEquipment companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar ===9 && (
								<SchoolProtocol companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.11 && (
								<PatentTransferManage companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.12 && (
								<OpenInnovation companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.13 && (
								<TechPersonTrain companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.14 && (
								<TechPersonRefresh companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.15 && (
								<TalentAcquisition companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.16 && (
								<PerformanceReview companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.17 && (
								<RDEquipmentPhoto companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.18 && (
								<RDExpense companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 10 && (
								<HonorQualification companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 12 && (
								<FinallyFile companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
						</div>
					</div>:
					<div className="content-frame-close">
						<div className="content-form-close">
							{
								this.state.tabBar === 11 &&(
									<CompanyPaceMain companyName={this.state.companyName} companyId={this.state.companyId}/>
								)
							}
							{this.state.tabBar === 0 && (
								<EnterpriseRegistration/>
							)
							}
							{this.state.tabBar === 0.1 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.2 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.3 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.4 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.5 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.6 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.7 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.8 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 0.9 && (
								<div>国网内容</div>
							)
							}
							{this.state.tabBar === 1.1 && (
								<RegisterCertificatePapers companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 1.2 && (
								<TechnicalFieldDescription companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.1 && (
								<IPNonReuse companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.2 && (
								(this.state.area === '青岛')?
									<IPSummaryTableQingdao
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>:
									<IPSummaryTable
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>
							)
							}
							{this.state.tabBar === 2.3 && (
								<IPGeneralSituation companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.4 && (
								<IPUploadSupportPapers companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 2.5 && (
								<IPFunction companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.1 && (
								<ResearchAuditReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.2 && (
								<ProductAuditReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.3 && (
								<FinancialAuditReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.4 && (
								<TaxForm companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 3.5 && (
								<IntermediaryProof companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 4.1 && (
								(this.state.area === '青岛')?
									<PatentTransferSummaryQingdao
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>:
									<PatentTransferSummary
										companyName={this.state.companyName}
										companyId={this.state.companyId}
									/>
							)
							}
							{this.state.tabBar === 4.2 && (
								<OverallCondition companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 4.3 && (
								<ItemCondition companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 4.4 && (
								<SupportingPapersQingdao
									companyName={this.state.companyName}
									companyId={this.state.companyId}
								/>
								// (this.state.area === '青岛')?
								// 	<SupportingPapersQingdao
								// 		companyName={this.state.companyName}
								// 		companyId={this.state.companyId}
								// 	/>:
								// 	<SupportingPapers
								// 		companyName={this.state.companyName}
								// 		companyId={this.state.companyId}
								// 	/>
							)
							}
							{this.state.tabBar === 5 && (
								<BuildProject companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.1 && (
								<BuildProjectSummary companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.2 && (
								<BuildProjectResolution companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.3 && (
								<ProjectReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 5.4 && (
								<ReceivingReport companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 6.1 && (
								<StaffSituation companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 6.2 && (
								<StaffRoster companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 6.3 && (
								<StaffStructure
									companyName={this.state.companyName}
									companyId={this.state.companyId}
								/>
							// 	(this.state.area === '江苏')?
							// 		<StaffStructureJiangsu
							// 			companyName={this.state.companyName}
							// 			companyId={this.state.companyId}
							// 		/>:
							// 		<StaffStructure
							// 			companyName={this.state.companyName}
							// 			companyId={this.state.companyId}
							// 		/>
							)
							}
							{this.state.tabBar === 6.4 && (
								<StaffSecurity companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 7.1 && (
								<HighTechSpecific companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 7.2 && (
								<HighTechUpload  companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.1 && (
								<OrganizationOverAll companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.2 && (
								<OrganizationItem  companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.3 && (
								<RDProjectManage companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.4 && (
								<RDInvestManage companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.5 && (
								<RDAuxiliaryAccount companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.6 && (
								<ReserveFund companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.7 && (
								<RDCenterFound companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.8 && (
								<RDCenter companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.9 && (
								<RDEquipment companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar ===9 && (
								<SchoolProtocol companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.11 && (
								<PatentTransferManage companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.12 && (
								<OpenInnovation companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.13 && (
								<TechPersonTrain companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.14 && (
								<TechPersonRefresh companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.15 && (
								<TalentAcquisition companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.16 && (
								<PerformanceReview companyId={this.state.companyId} companyName={this.state.companyName}/>
							)
							}
							{this.state.tabBar === 8.17 && (
								<RDEquipmentPhoto companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 8.18 && (
								<RDExpense companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 10 && (
								<HonorQualification companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
							{this.state.tabBar === 12 && (
								<FinallyFile companyName={this.state.companyName} companyId={this.state.companyId}/>
							)
							}
						</div>
					</div>
						}
					</div>
				</div>
			</Fragment>
		);
	}
}


export default Navigation;